module.exports = " <div _v-0f471a82=\"\"> <d-header _v-0f471a82=\"\"></d-header> <div class=view-container _v-0f471a82=\"\"> <placeholder class=\"placeholder animated\" v-show=isShowPlaceholder transition=fade _v-0f471a82=\"\"></placeholder> <router-view transition=trans _v-0f471a82=\"\"></router-view> </div> <d-footer style=\"overflow: hidden\" _v-0f471a82=\"\"></d-footer> <scroll-to-top _v-0f471a82=\"\"></scroll-to-top> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-0f471a82!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 610
 ** module chunks = 2
 **/